import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from "../grid.base.case";
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { MessageclientService } from 'src/service/messageclient.service';
import { CommonService} from '../../../../service/common.service';
declare var app;

@Component({
  selector: 'app-mz-grid-list-img1',
  templateUrl: './mz-grid-list-img1.component.html',
  styleUrls: ['./mz-grid-list-img1.component.scss']
})
export class MzGridListImg1Component extends GridBaseCase {
  dataArrayList: Array<any> = [];
  pageName: string;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private router: Router,
    private com:CommonService
  ) { super(); }

  LoadData() {
    let that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    // that.element.selectItemList.selectItem.forEach(function (item) {
    //   if (item.align == "id") {
    //     that.fieldItem['idKey'] = item.field;
    //   } else if (item.align == 'left') {
    //     that.fieldItem['imgKey'] = item.field;
    //   } else if (item.align == 'right' && item.level == '1') {
    //     that.fieldItem['titleKey'] = item.field;
    //   } else if (item.align == 'right' && item.level == '2') {
    //     that.fieldItem['timeKey'] = item.field;
    //   } else if (item.align == 'right' && item.level == '3') {
    //     that.fieldItem['locationKey'] = item.field;
    //   } else if (item.align == 'right' && item.level == '4') {
    //     that.fieldItem['statusKey'] = item.field;
    //   }
    // })
    that.pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.Name = that.element.name;
    body.Client.PageName = that.pageName;
    // if (that.platform.is("android")) {
    //   body.Client.ClientType = 0;
    // } else if (that.platform.is("ios")) {
    //   body.Client.ClientType = 1;
    // }

    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      that.dataArrayList = [];
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
            if (element.bindingField == 'date' && item[element.field]) {
              objfield[element.bindingField] = item[element.field].replace('00:00:00','');
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log(that.dataArrayList);
        });
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }

  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        console.log(evs, parms);
      } else {
        localStorage.setItem('element', JSON.stringify(ev));
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/" + ev.selectItemList.gridViewConfigName + "/" + parms.id);
        this.com.Go(evs + "/" + ev.selectItemList.gridViewConfigName + "/" + parms.id);
      }
    }

  }
  /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event) {
    this.LoadData();
    event.target.complete();
  }
}
